export default {
    ART_ROSS_TROPHY: 'art-ross-trophy',
    BILL_MASTERTON_MEMORIAL_TROPHY: 'bill-masterton-memorial-trophy',
    CALDER_MEMORIAL_TROPHY: 'calder-memorial-trophy',
    CLARENCE_S_CAMPBELL_BOWL: 'clarence-s-campbell-bowl',
    CONN_SMYTHE_TROPHY: 'conn-smythe-trophy',
    EJ_MCGUIRE_AWARD_OF_EXCELLENCE: 'e-j-mcguire-award-of-excellence',
    FRANK_J_SELKE_TROPHY: 'frank-j-selke-trophy',
    HART_MEMORIAL_TROPHY: 'hart-memorial-trophy',
    JACK_ADAMS_AWARD: 'jack-adams-award',
    JAMES_NORRIS_MEMORIAL_TROPHY: 'james-norris-memorial-trophy',
    JIM_GREGORY_GENERAL_MANAGER_OF_THE_YEAR_AWARD: 'jim-gregory-general-manager-of-the-year-award',
    KING_CLANCY_MEMORIAL_TROPHY: 'king-clancy-memorial-trophy',
    LADY_BYNG_MEMORIAL_TROPHY: 'lady-byng-memorial-trophy',
    LESTER_PATRICK_TROPHY: 'lester-patrick-trophy',
    MARK_MESSIER_NHL_LEADERSHIP_AWARD: 'mark-messier-nhl-leadership-award',
    MAURICE_ROCKET_RICHARD_TROPHY: 'maurice-rocket-richard-trophy',
    NHL_FOUNDATION_PLAYER_AWARD: 'nhl-foundation-player-award',
    NHL_LIFETIME_ACHIEVEMENT_AWARD: 'nhl-lifetime-achievement-award',
    PRESIDENTS_TROPHY: 'presidents-trophy',
    PRINCE_OF_WALES_TROPHY: 'prince-of-wales-trophy',
    STANLEY_CUP: 'stanley-cup',
    TED_LINDSAY_AWARD: 'ted-lindsay-award',
    VEZINA_TROPHY: 'vezina-trophy',
    WILLIAM_M_JENNINGS_TROPHY: 'william-m-jennings-trophy',
    WILLIE_O_REE_COMMUNITY_HERO_AWARD: 'willie-o-ree-community-hero-award',
};
